"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENTS = exports.STATES = void 0;
const xstate_1 = require("xstate");
exports.STATES = {
    noSearch: '@states/noSearch',
    blankSearch: '@states/blankSearch',
    hasResults: '@states/hasResults',
    noResults: '@states/noResults' // valid search query with no results
};
exports.EVENTS = {
    searchTermUpdated: '@events/searchTermUpdated'
};
const searchReviews = (reviews = [], term = '') => {
    if (!term) {
        return reviews;
    }
    return reviews.filter((review) => {
        const sanitizedTerm = term.trim().toLowerCase();
        // Skip reviews with null or undefined body
        if (!review.body) {
            return false;
        }
        const sanitizedReviewBody = review.body.trim().toLowerCase();
        return sanitizedReviewBody.includes(sanitizedTerm);
    });
};
const guards = {
    emptySearchTerm: (context, event) => event.data.length === 0,
    blankSearchTerm: (context, event) => event.data.trim().length === 0,
    hasResults: (context, event) => searchReviews(context.reviews, event.data).length > 0
};
const actions = {
    updateTerm: (0, xstate_1.assign)({
        searchTerm: (context, event) => event.data
    }),
    searchReviews: (0, xstate_1.assign)({
        displayReviews: (context) => searchReviews(context.reviews, context.searchTerm)
    }),
    resetSearch: (0, xstate_1.assign)({
        displayReviews: (context) => context.reviews
    })
};
const createSearchReviewsMachine = ({ reviews }) => (0, xstate_1.createMachine)({
    id: 'search-reviews-machine',
    initial: exports.STATES.noSearch,
    context: {
        reviews,
        searchTerm: '',
        displayReviews: reviews
    },
    on: {
        [exports.EVENTS.searchTermUpdated]: [
            {
                cond: 'emptySearchTerm',
                actions: ['updateTerm', 'resetSearch'],
                target: exports.STATES.noSearch
            },
            {
                cond: 'blankSearchTerm',
                actions: 'updateTerm',
                target: exports.STATES.blankSearch
            },
            {
                cond: 'hasResults',
                actions: ['updateTerm', 'searchReviews'],
                target: exports.STATES.hasResults
            },
            {
                actions: ['updateTerm'],
                target: exports.STATES.noResults
            }
        ]
    },
    states: {
        [exports.STATES.noSearch]: {},
        [exports.STATES.blankSearch]: {},
        [exports.STATES.hasResults]: {},
        [exports.STATES.noResults]: {}
    }
}, {
    guards,
    actions
});
exports.default = createSearchReviewsMachine;
//# sourceMappingURL=search-reviews-machine.js.map